import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltRecorderPlayerTimelineSeekBarWireframe from './VeltRecorderPlayerTimelineSeekBarWireframe/VeltRecorderPlayerTimelineSeekBarWireframe';
var VeltRecorderPlayerTimelineWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-timeline-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderPlayerTimelineWireframe.SeekBar = VeltRecorderPlayerTimelineSeekBarWireframe;
export default VeltRecorderPlayerTimelineWireframe;
